import React, { useState, useEffect } from 'react'
import { Card, ContentLoader, NotificationWindowsExample } from '../../../../_components'
import { history } from '../../../../_helpers'
import { momentumService } from '../../../../_services'
import { tmd } from '../../_functions'
import moment from 'moment'
import ptBR from 'moment/locale/pt-br'
import styles from '../../styles.module.scss'
import { intervalQueryPosfix } from '../Trigger/_Interval'
import { notificationIntervalRecurrency } from '../Channel/_Notification'
import { finishOptions } from '../Finish'

moment.locale('pt-br', ptBR)

const transformArrayToEndAndText = ( arrayOfString, andText = 'e' ) => {
  if ( !arrayOfString.length ) return ''
  if ( arrayOfString.length === 1 ) return arrayOfString[0]
  const itemsWithComma = arrayOfString.slice( 0, arrayOfString.length - 1 ).join( ', ' )
  const lastItem = arrayOfString[arrayOfString.length - 1 ]
  return `${itemsWithComma} ${andText} ${lastItem}`
}

export const Confirmation = ({receivedData, queryType, viewOnly}) => {
  const [ data, setData ] = useState(receivedData)

  useEffect( () => setData( receivedData ), [ receivedData ] )

  useEffect(() => {
    if ( !viewOnly || history.location.search.indexOf("ref") === -1) return

    async function getSingleMomentumData() {
      const momentum_uuid = history.location.search.split("&")[0].split("=")[1]
      const momentum = await momentumService.listMomentumById(momentum_uuid)

      const momentumObjectGroup = {
        title: momentum.data.momentum_title,
        updated_at: momentum.data.updated_at,
        worktime: momentum.data.worktime
      }

      const trigger = momentum.data.momentums.find( ( { type } ) => type === 'trigger' )?.values?.[0]
      const dispatcher = momentum.data.momentums.find( ( { type } ) => type === 'dispatcher' )?.values?.[0]
      const finish = momentum.data.momentums.find( ( { type } ) => type === 'finish' )?.values?.[0]

      momentum.data.momentums.forEach( m => momentumObjectGroup[m.type] = m.values[0] )

      momentumObjectGroup.raw_finish_filter = finishOptions.find( option => option.value === finish?.filter )
      momentumObjectGroup.raw_finish_value = finish?.value
      momentumObjectGroup.raw_intervalRecurrency = dispatcher?.intervalRecurrency?.map( intervalRecurrency => {
        let reducedIntervalRecurrency = Number( intervalRecurrency )
  
        const minimunIntervalQuery = Math.min( ...Object.values( notificationIntervalRecurrency ) )
        const dischargeInObject = {}
  
        while( reducedIntervalRecurrency > minimunIntervalQuery ) {
          // eslint-disable-next-line no-loop-func
          const intervalQueryPostfixKey = Object.keys( notificationIntervalRecurrency ).find( ( key ) => {
            const value = notificationIntervalRecurrency[key]
            if ( reducedIntervalRecurrency >= value ) return true
            return false
          } )
  
          const intervalQueryPostfixValue = notificationIntervalRecurrency[intervalQueryPostfixKey]
          reducedIntervalRecurrency -= intervalQueryPostfixValue
          dischargeInObject[intervalQueryPostfixKey] = ( dischargeInObject[intervalQueryPostfixKey] ?? 0 ) + 1
        }
  
        const query = Object.entries( dischargeInObject ).map( ( [ key, qty ] ) => `${qty}${key}` ).join( ' ' )

        return { label: query, value: query }
      } )

      momentumObjectGroup.raw_dischargeIn = trigger?.dischargeIn?.map( dischargeIn => {
        let reducedDischargeIn = Number( dischargeIn )

        const minimunIntervalQuery = Math.min( ...Object.values( intervalQueryPosfix ) )
        const dischargeInObject = {}

        while( reducedDischargeIn > minimunIntervalQuery ) {
          // eslint-disable-next-line no-loop-func
          const intervalQueryPostfixKey = Object.keys( intervalQueryPosfix ).find( ( key ) => {
            const value = intervalQueryPosfix[key]
            if ( reducedDischargeIn >= value ) return true
            return false
          } )

          const intervalQueryPostfixValue = intervalQueryPosfix[intervalQueryPostfixKey]
          reducedDischargeIn -= intervalQueryPostfixValue
          dischargeInObject[intervalQueryPostfixKey] = ( dischargeInObject[intervalQueryPostfixKey] ?? 0 ) + 1
        }

        const query = Object.entries( dischargeInObject ).map( ( [ key, qty ] ) => `${qty}${key}` ).join( ' ' )

        return { label: query, value: query }
      } )
      
      setData( momentumObjectGroup )
    }
    getSingleMomentumData()
  }, [viewOnly])

  return (
    <Card
      title={receivedData ? "Resumo" : `${!data?.title ? "Carregando informações..." : `Visualizando: ${data?.title}`}`}
      icon="FileIcon"
      expanded={true}
    >
      { 
        data || receivedData ?
          <>
            <div className={styles['summary__text-group']}>
              <p className={styles['text-group__title']}>{!viewOnly ? "Planejamento feito em:" : "Última atualização feita em:"}</p>
              <p className={styles['text-group__description']}>{!viewOnly ? moment().format('LLL') : moment(data.updated_at).format('LLL')}</p>
            </div>

            { ( data?.filter?.filter || receivedData?.raw_filter_type ) && (
              <>
                <hr className={styles['content-spacing']}/>
                <div className={styles['summary__text-group']}>
                  <p className={styles['text-group__title']}>Filtrando base por:</p>
                  <p className={styles['text-group__description']}>
                    <span>{receivedData?.raw_filter_type ? receivedData?.raw_filter_type?.label : tmd(data?.filter?.filter)}</span>
                    {
                      receivedData?.raw_filter_type?.value !== "all" && data?.filter?.filter !== "all" ?
                        <>{receivedData?.raw_filter_comparation ? " "+receivedData?.raw_filter_comparation.label+" " : " "+tmd(data?.filter?.comparation)+" "}
                        <span>{receivedData?.raw_filter_value ? receivedData?.raw_filter_value.map((d, i) => `${i > 0 ? `, ` : ''}${d.label}`) : data?.filter?.value}</span></>
                      : null
                    }
                  </p>
                </div>
              </>
            ) }

            { ( receivedData?.raw_trigger_type || data?.trigger?.filter ) && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>Gatilho definido para:</p>
                    <p className={styles['text-group__description']}>
                      <span>
                        {receivedData?.raw_trigger_type
                          ? receivedData?.raw_trigger_type.label
                          : tmd(data?.trigger?.filter)}
                      </span>
                      {' '}
                      {receivedData?.raw_trigger_comparation
                        ? receivedData?.raw_trigger_comparation.label
                        : tmd(data?.trigger?.comparation)}
                      {' '}
                      <span>
                        {receivedData?.raw_trigger_value
                          ? receivedData?.raw_trigger_value
                          : Array.isArray(data?.trigger?.value)
                            ? data?.trigger?.value.join(', ')
                            : data?.trigger?.value}
                      </span>
                    </p>
                  </div>
                </>
              ) }

            {
              !!data?.raw_dischargeIn?.length && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>Intervalo:</p>
                    <p className={styles['text-group__description']}>
                      <span>
                        { data.raw_dischargeIn.map( dischargeIn => dischargeIn.label ).join( ' ' ) }
                      </span>
                    </p>
                  </div>
                </>
              )
            }

            { !!data?.worktime && (
              <>
                <hr className={styles['content-spacing']}/>
                <div className={styles['summary__text-group']}>
                  <p className={styles['text-group__title']}>Cronograma:</p>
                  <p className={styles['text-group__description']}>
                    <span>
                      { transformArrayToEndAndText(
                        [ 'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado' ]
                          .filter( ( weekDayLabel, weekDayValue ) => data.worktime.weekdays.includes( weekDayValue ) )
                      ) }
                      { ' ' }
                      às {data.worktime.start_at} até {data.worktime.stop_at}
                    </span>
                  </p>
                </div>
              </>
            ) }

            {
              !!data?.raw_intervalRecurrency?.length && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>Notificação recorrente:</p>
                    <p className={styles['text-group__description']}>
                      <span>
                        { data.raw_intervalRecurrency.map( intervalRecurrency => intervalRecurrency.label ).join( ' ' ) }
                      </span>
                    </p>
                  </div>
                </>
              )
            }

            {
              !!data?.dispatcher?.redirect_uri && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>URL de redirecionamento:</p>
                    <p className={styles['text-group__description']}>
                      <span>
                        { data.dispatcher.redirect_uri }
                      </span>
                    </p>
                  </div>
                </>
              )
            }

            {
              !!data?.raw_finish_filter && !!data?.raw_finish_value && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>{data.raw_finish_filter.label}:</p>
                    <p className={styles['text-group__description']}>
                      <span>
                        {moment( data.raw_finish_value ).format( 'LLL' )}
                      </span>
                    </p>
                  </div>
                </>
              )
            }

            { ( ( receivedData?.raw_dispatcher_type && receivedData?.raw_dispatcher_type?.label === "Notificações push" ) || data?.dispatcher ) && (
                <>
                  <hr className={styles['content-spacing']}/>
                  <div className={styles['summary__text-group']}>
                    <p className={styles['text-group__title']}>Canal escolhido:</p>
                    <p className={styles['text-group__description']}>
                      <span>{receivedData?.raw_dispatcher_type ? receivedData?.raw_dispatcher_type.label : tmd(data?.dispatcher?.filter)}</span>
                      <br/><br/>
                      <NotificationWindowsExample data={receivedData?.dispatcher ? receivedData?.dispatcher : data?.dispatcher} viewOnly={true}/>
                    </p>
                  </div>
                </>
              ) }

          </>
        : <>
          <ContentLoader height="20px" width="40%"/>
          <br/>
          <ContentLoader height="20px" width="40%"/>
          <br/>
          <ContentLoader height="150px" width="40%"/>
        </>
      }
    </Card>
  )
}